import Utility from './utility';

let Plugins = {
    init: () => {
        let defaultWhiteList = $.fn.tooltip.Constructor.Default.whiteList
        defaultWhiteList['*'].push(/^data-[\w-]*$/i);

        Plugins.initPopups();
        Plugins.initTooltips();
    },

    initTooltips: () => {
        $('[data-toggle="tooltip"]').each(function () {
            let $this = $(this);

            if ($this.hasClass('tooltip-feature-discovery')) {
                $this.tooltip({
                    trigger: 'manual',
                    animation: true,
                    template:
                        '<div class="tooltip tooltip-feature-discovery" role="tooltip">' +
                        '<div class="blinker">' +
                        '<div class="blinker-outer"></div>' +
                        '<div class="blinker-inner"></div>' +
                        '</div>' +
                        '<div class="tooltip-inner"></div>' +
                        '</div>'
                }).on('click', () => $this.tooltip('hide'));

                if ($this.is(":visible")) {
                    $this.tooltip('show');
                    setTimeout(() => $this.tooltip('hide'), 30000)
                }
            } else {
                $this.tooltip({boundary: 'window'});
            }
        });
    },

    initPopups: () => {
        $('[data-toggle="popover"]').each(function () {
            let $this = $(this),
                hasTrigger = this.hasAttribute('data-trigger'),
                event1 = 'mouseenter',
                event2 = 'mouseleave';

            if (Utility.isTouchDevice()) {
                event1 = 'touchstart';
                event2 = 'touchend';
            }

            $this.popover({
                trigger: hasTrigger ? $this.data('trigger') : 'manual',
                html: true,
                boundary: 'viewport',
                content: function () {
                    return $this.next('.popover-content').html();
                }
            })

            if (!hasTrigger) {
                $this.on(event1, function () {
                    let _this = this;
                    $(this).popover('show');
                    $('.popover').on(event2, () => {
                        $(_this).popover('hide');
                    });
                }).on(event2, function () {
                    var _this = this;
                    setTimeout(() => {
                        if (!$('.popover:hover').length) {
                            $(_this).popover('hide');
                        }
                    }, 500);
                });
            }
        });
    }
};

export default Plugins;
